(function () {
  'use strict';

  // Nail polish shade -> product photo, sourced from each polish's featured image.
  var IMAGE_MAP = {
    '02 Sunset Boulevard': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-02-sunset-boulevard.jpg?v=1669869917',
    '04 Tabou': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-04-tabou.jpg?v=1669869917',
    '05 Sweet Life': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-05-sweet-life.jpg?v=1669869917',
    '06 Darling Nikki': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-06-darling-nikki.jpg?v=1669869915',
    '11 Pearl of a Girl': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-11-pearl-of-a-girl.jpg?v=1669102991',
    '13 Kitten': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-13-kitten.jpg?v=1669103006',
    '14 Hussy': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-14-hussy.jpg?v=1669103010',
    '15 Santa Sangre': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-15-santa-sangre.jpg?v=1669103007',
    '17 Deep Sea': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-17-deep-sea.jpg?v=1669103011',
    '18 Soft Focus': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-18-soft-focus.jpg?v=1669103012',
    '20 Retrograde': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-20-retrograde.jpg?v=1669103010',
    '22 Diabolique': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-22-diabolique.jpg?v=1669103005',
    '23 Ingenue': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-23-ingenue.jpg?v=1669103008',
    '24 Tanlines': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-24-tanlines.jpg?v=1669103009',
    '28 Swimming Pool': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Swimming_Pool.png?v=1770782041',
    '29 Scarab': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-29-scarab.jpg?v=1669103006',
    '33 Space Cadet': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-33-space-cadet.jpg?v=1669103006',
    '36 Moon Rock': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-10-Free-Vegan-Cruelty-Free-Nail-Polish-Color-36-Moon-Rock-Square.webp?v=1770782086',
    '39 Voyeur': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-39-voyeur.jpg?v=1669102999',
    '40 Nymph': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-40-nymph.jpg?v=1669103001',
    '41 Terra': 'https://cdn.shopify.com/s/files/1/0219/0588/products/habit-cosmetics-skincare-ingredient-infused-non-toxic-vegan-nail-polish-in-41-terra.jpg?v=1669103000',
    '42 Cavalier': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Cavalier.png?v=1770782123',
    '45 Belladonna': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-10-Free-Vegan-Cruelty-Free-Nail-Polish-Color-45-Belladonna.webp?v=1770782142',
    '47 Cat Lady': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-10-Free-Vegan-Cruelty-Free-Nail-Polish-Color-47-Cat-Lady.webp?v=1770782167',
    '49 Tandoori': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Tandoori.png?v=1770782190',
    '51 Scorpio Rising': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-10-Free-Vegan-Cruelty-Free-Nail-Polish-Color-51-Scorpio-Rising.webp?v=1770782207',
    '53 Daisy Chain': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Daisy_Chain.png?v=1770782306',
    '55 Bop Bop!': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Bop_Bop.png?v=1770782323',
    '56 Jolly Bean Green': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Jolly_Bean_Green.png?v=1770782331',
    '57 Blue Jean Baby': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Blue_Jean_Baby.png?v=1770782339',
    '63 Mimosa Mami': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Mimosa_Mami.png?v=1770782373',
    '64 Golden Hour': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-10-Free-Vegan-Cruelty-Free-Nail-Polish-Color-64-Golden-Hour.webp?v=1770782379',
    "66 90's Baby": 'https://cdn.shopify.com/s/files/1/0219/0588/files/90_s_Baby.png?v=1770782824',
    '67 Bootleg': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Bootleg.png?v=1770782589',
    '68 BAPS': 'https://cdn.shopify.com/s/files/1/0219/0588/files/BAPS.png?v=1770782597',
    '71 Forbidden Fruit': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Forbidden_Fruit.png?v=1770782622',
    '72 Versayce': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Versayce.png?v=1770782630',
    '73 Brownie Points': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Brownie_Points.png?v=1770782639',
    '74 Night Drive': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Night_Drive.png?v=1770782663',
    '75 Rich Bitch': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-21-Free-Vegan-Cruelty-Free-Nail-Polish-Color-75-RichBitch.webp?v=1770782669',
    '76 Bam Bam': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Bam-Bam.jpg?v=1770673667',
    '77 Clementine': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Clementine.jpg?v=1770671175',
    '78 Sashimi': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Sashimi.jpg?v=1770671145',
    '79 Oyster': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Oyster.jpg?v=1770671096',
    '80 Caviar': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Caviar.jpg?v=1770671068',
    '81 Laura Palmer': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Laura-Palmer.jpg?v=1770670784',
    '82 Bonsai': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Bonsai.jpg?v=1770670632',
    '83 Chocolate Cherry': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-21-Free-Vegan-Cruelty-Free-Nail-Polish-Color-83-Chocolate-Cherry.jpg?v=1755848153',
    '85 Coconut': 'https://cdn.shopify.com/s/files/1/0219/0588/files/PantoneOTY2025.png?v=1770782859',
    'Base': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Habit-Cosmetics-10-Free-Vegan-Cruelty-Free-Nail-Polish--Base_Coat_New_Formula_2964c9a3-257b-474a-a0d9-f669f5113801.webp?v=1770782009',
    'Top': 'https://cdn.shopify.com/s/files/1/0219/0588/files/Top_Coat_2.png?v=1775861328'
  };

  function sizedUrl(url) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=500';
  }

  function slotFromName(name) {
    var match = name.match(/Pick Color #(\d+)/);
    return match ? match[1] : null;
  }

  function buildPreview() {
    var mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return null;

    var viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return null;

    var existing = viewer.querySelector('.pcs-preview');
    if (existing) return existing;

    var preview = document.createElement('div');
    preview.className = 'pcs-preview';

    var selects = document.querySelectorAll('select[name^="properties[Pick Color"]');
    selects.forEach(function (select) {
      var slot = slotFromName(select.name);
      if (!slot) return;

      var item = document.createElement('div');
      item.className = 'pcs-preview-item';
      item.dataset.slot = slot;

      var img = document.createElement('img');
      img.alt = '';
      item.appendChild(img);

      var label = document.createElement('div');
      label.className = 'pcs-preview-label';
      item.appendChild(label);

      preview.appendChild(item);
    });

    viewer.appendChild(preview);
    return preview;
  }

  function updateSlot(preview, slot, name) {
    var item = preview.querySelector('.pcs-preview-item[data-slot="' + slot + '"]');
    if (!item) return;
    if (item.dataset.current === (name || '')) return;
    item.dataset.current = name || '';

    var img = item.querySelector('img');
    var label = item.querySelector('.pcs-preview-label');
    var url = IMAGE_MAP[name];

    if (url) {
      img.classList.remove('is-loaded');
      img.src = sizedUrl(url);
      img.alt = name;
      img.onload = function () {
        img.classList.add('is-loaded');
      };
    } else {
      img.removeAttribute('src');
      img.classList.remove('is-loaded');
    }

    label.textContent = name || '';
  }

  function init() {
    var selects = document.querySelectorAll('select[name^="properties[Pick Color"]');
    if (!selects.length) return;

    var preview = buildPreview();
    if (!preview) return;

    selects.forEach(function (select) {
      var slot = slotFromName(select.name);
      if (!slot) return;

      updateSlot(preview, slot, select.value);

      if (!select.dataset.pcsPreviewBound) {
        select.dataset.pcsPreviewBound = 'true';
        select.addEventListener('change', function () {
          updateSlot(preview, slot, select.value);
          preview.classList.add('is-active');
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  init();

  var observer = new MutationObserver(function () {
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
